import { render } from "./HeaderGroup.vue?vue&type=template&id=00416128&scoped=true"
const script = {}

import "./HeaderGroup.vue?vue&type=style&index=0&id=00416128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00416128"]])

export default __exports__